import React, { useMemo, useState } from 'react';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';

const LIMIT = 200;
const words = (s) => (s || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
const hit = (text, ws) => { const t = (text || '').toLowerCase(); return ws.every((w) => t.includes(w)); };
const custText = (c) => `${c.label} ${c.name} ${c.code} ${c.customer_id}`;

/** Vendor + customer search list; filters itself (every typed word, any punctuation) and shows the first 200 of each group. */
export const PartyCommand = ({ vendors, customers, onVendor, onCustomer, ids, wrap = false, listClassName, emptyText = 'No party found.' }) => {
  const [q, setQ] = useState('');
  const { v, c, more } = useMemo(() => {
    const ws = words(q);
    const fv = ws.length ? vendors.filter((n) => hit(n, ws)) : vendors;
    const fc = ws.length ? customers.filter((x) => hit(custText(x), ws)) : customers;
    return { v: fv.slice(0, LIMIT), c: fc.slice(0, LIMIT), more: Math.max(0, fv.length - LIMIT) + Math.max(0, fc.length - LIMIT) };
  }, [q, vendors, customers]);
  const text = wrap ? 'flex-1 whitespace-normal break-words' : 'flex-1 truncate';
  return (
    <Command shouldFilter={false}>
      <CommandInput value={q} onValueChange={setQ} placeholder="Search vendor or customer..." data-testid={ids.search} />
      <CommandList className={listClassName}>
        <CommandEmpty>{emptyText}</CommandEmpty>
        {v.length > 0 && (
          <CommandGroup heading="Vendors">
            {v.map((vendor) => (
              <CommandItem key={`v-${vendor}`} value={`v-${vendor}`} onSelect={() => onVendor(vendor)} className="cursor-pointer" data-testid={ids.vendor}>
                <span className={text}>{vendor}</span>
                <span className="ml-2 text-[9px] uppercase tracking-wider text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded">Vendor</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {c.length > 0 && (
          <CommandGroup heading="Customers (Sales Return)">
            {c.map((cust, i) => (
              <CommandItem key={`c-${cust.code || cust.customer_id || cust.name}-${i}`} value={`c-${i}-${cust.customer_id || cust.code}-${cust.label || cust.name}`}
                onSelect={() => onCustomer(cust)} className="cursor-pointer" data-testid={ids.customer}>
                <span className={text} data-testid={ids.label}>
                  {cust.label || cust.name}
                  {cust.code && <span className="ml-1.5 text-[10px] text-gray-400">({cust.code})</span>}
                </span>
                <span className="ml-2 text-[9px] uppercase tracking-wider text-amber-700 bg-amber-50 px-1.5 py-0.5 rounded">Customer</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
      {more > 0 && (
        <p className="border-t px-3 py-1.5 text-[11px] text-gray-500" data-testid={ids.more}>
          {more.toLocaleString('en-IN')} more — type more of the name to narrow the list
        </p>
      )}
    </Command>
  );
};

export default PartyCommand;
